import { lazy } from "react";
import { BookOpen, ClipboardCheck, Fuel, Hammer, Trophy } from "lucide-react";
import { openRecord } from "../../web/forms/EventForm";
import { defineWebModule } from "../../web/module";
import "./web/operations.css";

// Pages load when opened, so the app starts fast on a phone with weak signal.
const AnimalShowsSection = lazy(() => import("./web/Shows").then((m) => ({ default: m.AnimalShowsSection })));
const AssetProblemsSection = lazy(() => import("./web/Equipment").then((m) => ({ default: m.AssetProblemsSection })));
const MaintenanceSection = lazy(() => import("./web/Equipment").then((m) => ({ default: m.MaintenanceSection })));
const PlaceProblemsSection = lazy(() => import("./web/Equipment").then((m) => ({ default: m.PlaceProblemsSection })));
const CalendarWorkspace = lazy(() => import("./web/Calendar").then((m) => ({ default: m.CalendarWorkspace })));
const EquipmentEventForm = lazy(() => import("./web/forms").then((m) => ({ default: m.EquipmentEventForm })));
const EquipmentWorkspace = lazy(() => import("./web/Equipment").then((m) => ({ default: m.EquipmentWorkspace })));
const IssueDetail = lazy(() => import("./web/forms").then((m) => ({ default: m.IssueDetail })));
const ProceduresSection = lazy(() => import("./web/Procedures").then((m) => ({ default: m.ProceduresSection })));
const RepairDetail = lazy(() => import("./web/forms").then((m) => ({ default: m.RepairDetail })));
const ShowJobPage = lazy(() => import("./web/Shows").then((m) => ({ default: m.ShowJobPage })));
const ShowsWorkspace = lazy(() => import("./web/Shows").then((m) => ({ default: m.ShowsWorkspace })));

export default defineWebModule({
  id: "operations",
  icons: { hammer: Hammer, fuel: Fuel, clipboardCheck: ClipboardCheck, trophy: Trophy, book: BookOpen },
  events: {
    "operations.service": { Form: EquipmentEventForm },
    "operations.repair": { Form: EquipmentEventForm, Detail: RepairDetail },
    "operations.issue": { Form: EquipmentEventForm, Detail: IssueDetail },
    "operations.meter": { Form: EquipmentEventForm },
    "operations.fuel": { Form: EquipmentEventForm },
    "operations.inspection": { Form: EquipmentEventForm },
  },
  animalSections: [{
    id: "shows",
    label: "Shows",
    order: 70,
    show: (a) => !!a.facets.operations || a.jobs.some((j) => j.type === "operations.show"),
    Component: AnimalShowsSection,
  }],
  animalActions: [{
    id: "show-result",
    label: "Record show result",
    icon: "trophy",
    priority: 10,
    when: (a) => a.jobs.some((j) => j.type === "operations.show"),
    run: (a) => {
      const show = a.jobs.find((j) => j.type === "operations.show");
      if (!show) return;
      openRecord({ initial: { type: "operations.show_result", job_id: show.id, subjects: [{ kind: "animal", id: a.id, role: "animal", label: a.label }], data: { show_name: show.title } } });
    },
  }],
  workspaces: { equipment: EquipmentWorkspace, calendar: CalendarWorkspace, shows: ShowsWorkspace },
  ranchSections: { procedures: ProceduresSection },
  jobs: { "operations.show": ShowJobPage },
  assetSections: [
    { id: "maintenance", label: "Maintenance", order: 10, Component: MaintenanceSection },
    { id: "problems", label: "Problems", order: 20, Component: AssetProblemsSection },
  ],
  placeSections: [{ id: "problems", label: "Problems", order: 40, show: (p) => !!(p.facets as Record<string, unknown> | undefined)?.operations, Component: PlaceProblemsSection }],
});
